import React, { useEffect, useState } from "react";
import "../../resources/scss/toast/main.scss";
import SuccessIcon from "./icons/SuccessIcon";
import WarningIcon from "./icons/WarningIcon";
import ErrorIcon from "./icons/ErrorIcon";
import InfoIcon from "./icons/InfoIcon";
import CloseIcon from "./icons/CloseIcon";

export interface IToastProps {
  message: React.ReactNode;
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  duration?: number;
  onClose?: () => void;
  type?: "success" | "error" | "info" | "warning";
  show?: boolean;
  startIcon?: React.ReactNode;
  closeIcon?: React.ReactNode;
}

const Toast: React.FC<IToastProps> = ({
  message,
  duration = 3000,
  onClose,
  type = "info",
  show = true,
  startIcon,
  closeIcon,
}) => {
  const [visible, setVisible] = useState(false);

  const getIcon = () => {
    switch (type) {
      case "success":
        return <SuccessIcon />;
      case "error":
        return <ErrorIcon />;
      case "info":
        return <InfoIcon />;
      case "warning":
        return <WarningIcon />;
      default:
        return <SuccessIcon />;
    }
  };

  useEffect(() => {
    if (show) {
      setVisible(true);

      if (duration && onClose) {
        const timer = setTimeout(() => {
          setVisible(false);
          setTimeout(onClose, 300);
        }, duration);
        return () => {
          clearTimeout(timer);
        };
      }
    } else {
      setVisible(false);
    }
  }, [show, duration, onClose]);

  if (!show && !visible) return null;

  return (
    <div
      className={`common_toast common_toast--${type} ${
        visible ? "toast-show" : ""
      }`}
    >
      {startIcon ? (
        <div className="common_toast_startIcon">{startIcon}</div>
      ) : (
        getIcon()
      )}
      <div className="common_toast_message">
        {typeof message === "string" ? (
          <span dangerouslySetInnerHTML={{ __html: message }} />
        ) : (
          message
        )}
      </div>
      {closeIcon ? (
        <button
          className="common_toast_closeIcon"
          onClick={() => {
            setVisible(false);
            setTimeout(() => {
              onClose?.();
            }, 300);
          }}
          aria-label="Close toast"
        >
          {closeIcon}
        </button>
      ) : (
        <div
          className="common_toast_closeIcon"
          onClick={() => {
            setVisible(false);
            setTimeout(() => {
              onClose?.();
            }, 300);
          }}
        >
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

export default Toast;
